import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { RegisterComponent } from "./components/RegisterComponent";
import { MapComponent } from "./components/MapComponent";
import { CharacterProfileComponent } from "./components/CharacterProfileComponent";
import { MiniGameComponent } from "./components/MiniGameComponent";
import { LoginComponent } from "./components/LoginComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-map", MapComponent);
window.customElements.define("game-register", RegisterComponent);
window.customElements.define("game-login", LoginComponent);
window.customElements.define("game-characterprofile", CharacterProfileComponent);
window.customElements.define("game-minigame", MiniGameComponent);
